import Vue from 'vue'

import _ from 'lodash'
import { v4 as uuid } from 'uuid';
var storage = window.localStorage;

export function processesPlugin() {
  return store => {

    store.commit("processes/init", JSON.parse(storage.getItem("processes") || "[]"));

    store.subscribe((mutation, { processes }) => {
      if(mutation.type.indexOf("processes") != -1) {
        storage.setItem("processes", JSON.stringify(processes.list));
      }
    });
  }
}

export default {
  namespaced: true,
  state: {
    list: []
  },
  mutations: {
    init(state, list) {
      var ts = Date.now() - 604800000;
      state.list = _.filter(list, (process) => {
        return process.created_at >= ts;
      });
      storage.setItem("processes", JSON.stringify(state.list));
    },
    add(state, process) {
      process = _.merge(process, {
        uuid: uuid(),
        created_at: Date.now(),
        status: "new"
      })
      state.list.push(process);
    },
    remove(state, uuid) {
      state.list = state.list.filter((p) => p.uuid != uuid);
    },
    clear(state) {
      state.list = [];
    }
  },
  getters: {
    list: state => {
      return state.list;
    }
  }
}
